import * as React from "react";
import { SVGProps } from "react";
export const PencilFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M16.188 7.542L12.458 3.812L13.479 2.792C13.8263 2.44466 14.2397 2.271 14.719 2.271C15.1983 2.271 15.6113 2.44466 15.958 2.792L17.208 4.042C17.5413 4.37533 17.708 4.78833 17.708 5.281C17.708 5.77433 17.5413 6.18766 17.208 6.521L16.188 7.542ZM3.375 17.5C3.139 17.5 2.934 17.4133 2.76 17.24C2.58667 17.066 2.5 16.861 2.5 16.625V14.125C2.5 14.0137 2.52067 13.906 2.562 13.802C2.604 13.698 2.66667 13.6043 2.75 13.521L11.229 5.042L14.958 8.771L6.479 17.25C6.39567 17.3333 6.302 17.396 6.198 17.438C6.094 17.4793 5.98633 17.5 5.875 17.5H3.375Z"
            fill="currentColor"
        />
    </svg>
);
PencilFillIcon.displayName = "PencilFillIcon";
